import React, { memo } from "react";
import { motion, useReducedMotion } from "motion/react";

const Animate = memo(
  ({
    children,
    cell,
    duration = 0.4,
    rowDelay = 0.04,
    columnDelay = 0.03,
    className = "",
  }) => {
    const reduceMotion = useReducedMotion();

    const rowIndex = cell?.row?.index ?? 0;

    const columnIndex = cell
      ? cell
          .getContext()
          .table.getVisibleLeafColumns()
          .findIndex((column) => column.id === cell.column.id)
      : 0;

    const delay =
      rowIndex * rowDelay +
      Math.max(0, columnIndex) * columnDelay;

    return (
      <motion.div
        className={className}
        initial={
          reduceMotion
            ? false
            : {
                opacity: 0,
                x: -16,
              }
        }
        animate={{
          opacity: 1,
          x: 0,
        }}
        transition={{
          duration,
          delay,
          ease: "easeOut",
        }}
      >
        {children}
      </motion.div>
    );
  },
);

Animate.displayName = "Animate";

export default Animate;